<template>
  <div>
    <div v-if="loaded" class="card card-custom gutter-b">
      <div class="card-body">
        <div class="table-responsive">
          <table
            class="table table-head-custom table-head-bg table-borderless table-vertical-center"
          >
            <thead>
              <tr>
                <th>دستگاه</th>
                <th>تاریخ</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="userToken in userTokens" :key="userToken.id">
                <td dir="ltr">{{ userToken.agent }}</td>
                <td dir="ltr" class="text-nowrap">
                  {{ formatDate(userToken.updated_at) }}
                </td>
                <td class="text-nowrap">
                  <button
                    class="btn btn-xs btn-outline-danger mr-1"
                    @click="destroy(userToken.id)"
                  >
                    <i class="flaticon2-trash"></i>
                    حذف
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SET_ACTIONS } from "@/core/services/store/actions.module";
import { FETCH_USER_TOKENS } from "@/core/services/store/tokens.module";
import { mapGetters } from "vuex";
import Swal from "sweetalert2";
import { DESTROY_USER_TOKEN } from "../../../core/services/store/tokens.module";

export default {
  name: "user-tokens",
  data() {
    return {
      loaded: false
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "نشست‌ها" }]);
    this.$store.dispatch(SET_ACTIONS, {});

    this.updateTokens();
  },
  computed: {
    ...mapGetters(["userTokens"])
  },
  methods: {
    updateTokens() {
      this.loaded = false;
      this.$store
        .dispatch(FETCH_USER_TOKENS)
        .then(() => {
          this.loaded = true;
        })
        .catch(() => {
          this.loaded = true;
        });
    },
    destroy(id) {
      Swal.fire({
        title: "",
        text: "آیا از حذف جلسه اطمینان دارید؟",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "بله",
        confirmButtonColor: "#4554a0",
        cancelButtonText: "خیر",
        cancelButtonColor: "#ed1c24",
        heightAuto: false
      }).then(result => {
        if (result.isConfirmed) {
          this.$store.dispatch(DESTROY_USER_TOKEN, id).then(() => {
            this.updateTokens();
          });
        }
      });
    }
  }
};
</script>
